import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/data.service';
import { ZaradekModalComponent } from 'src/app/components/zaradek-modal/zaradek-modal.component';
import { EntityPickerModalComponent } from 'src/app/components/entity-picker-modal/entity-picker-modal.component';

interface Csoport {
  id: string;
  name: string;
  ev?: number;
  hianyzas_szamit?: number | boolean;
  opcionalis_reszvetel?: number | boolean;
  /** tanorai / szakkor / sportkor / napkozi / tanuloszoba / egyeb; null = automatikus (a hiányzás-kapcsoló szerint). */
  foglalkozas_tipus?: string | null;
  tanulo_db?: number;
}

/*  A CSOPORT FOGLALKOZÁS-TÍPUSA (backend/csoport-nevsor.js FOGLALKOZAS_TIPUSOK). A tanórai csoport
 *  csoportnaplót kap (20/2012. EMMI r. 102. §), a többi egyéb foglalkozási naplót (103. §). A
 *  mulasztás számítását NEM állítja: arról továbbra is a hiányzás-kapcsoló dönt. */
const FOGLALKOZAS_TIPUSOK: { ertek: string; nev: string }[] = [
  { ertek: '', nev: 'Automatikus (a hiányzás-kapcsoló szerint)' },
  { ertek: 'tanorai', nev: 'Tanórai csoport (csoportnapló)' },
  { ertek: 'szakkor', nev: 'Szakkör' },
  { ertek: 'sportkor', nev: 'Sportkör' },
  { ertek: 'napkozi', nev: 'Napközi' },
  { ertek: 'tanuloszoba', nev: 'Tanulószoba' },
  { ertek: 'egyeb', nev: 'Egyéb foglalkozás (korrepetálás, felkészítés, fejlesztés…)' },
];

interface TanuloCsoportSor {
  oktazon: string;
  adid?: string;
  full_name: string;
  aktualis_osztaly?: string;
  csoportban: number | boolean;
  tagsag_kezdete?: string | null;
  tagsag_vege?: string | null;
  selected?: boolean;
}

/** Mai nap helyi idő szerint, YYYY-MM-DD alakban (a dátummezők alapértéke). */
function maiNap(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

@Component({
  selector: 'app-csoport-besorolas',
  templateUrl: './csoport-besorolas.component.html',
  styleUrls: ['./csoport-besorolas.component.scss'],
})
export class CsoportBesorolasComponent implements OnInit {
  sajatIntezmeny: any;
  csoportok: Csoport[] = [];
  tanulok: TanuloCsoportSor[] = [];
  szurtTanulok: TanuloCsoportSor[] = [];
  kivalasztottCsoport: Csoport | null = null;
  kereses = '';
  /*  ÓRA NÉLKÜLI CSOPORTOK. Vagy még nem kerültek be az órarendbe, vagy fölöslegesen
   *  jöttek létre – így vagy úgy, ezeket kell átnézni. A választóban szűrhetők. */
  csakOraNelkuli = false;
  /*  ÜRES CSOPORT: se névsora, se órája. Az „óra nélküli"-nél szűkebb kör, és
   *  kockázatmentesebb takarítás – itt nincs mit elveszíteni, ezért külön szűrhető
   *  és külön törölhető. */
  csakUres = false;
  tomegesTorles = false;
  csakTagok = false;
  betoltes = false;
  mentes = false;
  /*  A VÁLTOZÁS NAPJAI. Az újonnan felvett tanuló a BELÉPÉS napjától tag, a kivett
   *  tanuló tagsága a KILÉPÉS napja előtti nappal zárul (a régi névsor megmarad).
   *  Alapból mindkettő a mai nap; a csoport tanévén belül választható. */
  belepesNapja = maiNap();
  kilepesNapja = maiNap();

  // Csoport↔tantárgy társítás
  osszesTantargy: any[] = [];
  kivalasztottTantargyIds: string[] = [];
  tantargyMentes = false;

  // Átnevezés (a csoportra az azonosító hivatkozik, ezért ez nem szakít el semmit)
  ujNev = '';
  nevMentes = false;

  // Új csoport létrehozása
  ujCsoportForm = false;
  ujCsoport: { name: string; ev: number; hianyzas_szamit: boolean; opcionalis_reszvetel: boolean; foglalkozas_tipus: string } = {
    name: '', ev: new Date().getFullYear(), hianyzas_szamit: true, opcionalis_reszvetel: false, foglalkozas_tipus: '',
  };
  readonly foglalkozasTipusok = FOGLALKOZAS_TIPUSOK;
  csoportLetrehozasFolyamatban = false;

  constructor(private http: HttpClient, private data: DataService, private modalCtrl: ModalController) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.munkatanev = await this.data.getMunkatanev();
    this.csoportokBetoltese();
  }

  async zaradekokMegnyitasa(tanulo: TanuloCsoportSor) {
    const modal = await this.modalCtrl.create({
      component: ZaradekModalComponent,
      componentProps: {
        oktazon: tanulo.oktazon,
        tanuloNev: tanulo.full_name,
        intezmenyId: this.intezmenyId,
      },
    });
    await modal.present();
  }

  get intezmenyId(): string {
    return String(this.sajatIntezmeny?.intezmenyId || this.sajatIntezmeny?.id || '').trim();
  }

  /**
   *  Jelenléti ív a csoport névsorával – PDF (backend/jelenleti.js, a munkaidő-elszámolás
   *  arculatával), új lapon nyílik, nem letöltésként: a felhasználó látja, mit fog nyomtatni.
   */
  jelenletiIv() {
    if (!this.kivalasztottCsoport) return;
    //  Tokenes megnyitás: a linkes `window.open` nem vinné a belépési jegyet, a jelenléti
    //  ív pedig munkatársi végpont – kilét nélkül a kiszolgáló nem adja ki.
    const url = `/api/jelenleti/csoport/${encodeURIComponent(this.kivalasztottCsoport.id)}/${this.intezmenyId}`;
    this.data.megnyitFajl(url, 'jelenleti-iv');
  }

  // A csoport tanévhez kötött adat: MINDIG a munkatanévre szűrünk, különben a tavalyi
  // csoportok is megjelennének az idei listában (és fordítva).
  munkatanev: number | null = null;

  private get evParam(): string {
    return this.munkatanev != null ? `?ev=${this.munkatanev}` : '';
  }

  csoportokBetoltese() {
    if (!this.intezmenyId) return;
    this.betoltes = true;
    this.http.get<Csoport[]>(`/api/tanuloi-csoport/csoportok/${this.intezmenyId}${this.evParam}`).subscribe({
      next: (rows) => {
        this.csoportok = Array.isArray(rows) ? rows : [];
        this.betoltes = false;
      },
      error: () => {
        this.betoltes = false;
        this.data.sendToast('Nem sikerült betölteni a csoportokat.', 'error');
      },
    });
  }

  csoportLetrehozas() {
    if (!this.intezmenyId) return;
    const name = String(this.ujCsoport.name || '').trim();
    if (!name) { this.data.sendToast('Adj meg csoportnevet.', 'warning'); return; }
    this.csoportLetrehozasFolyamatban = true;
    const ev = Number(this.munkatanev) || Number(this.ujCsoport.ev) || new Date().getFullYear();
    this.http.post<any>(`/api/tanuloi-csoport/csoport/${this.intezmenyId}`, {
      name,
      ev,
      hianyzas_szamit: this.ujCsoport.hianyzas_szamit ? 1 : 0,
      opcionalis_reszvetel: (!this.ujCsoport.hianyzas_szamit && this.ujCsoport.opcionalis_reszvetel) ? 1 : 0,
      foglalkozas_tipus: this.ujCsoport.foglalkozas_tipus || null,
    }).subscribe({
      next: (resp) => {
        this.csoportLetrehozasFolyamatban = false;
        this.data.sendToast('A csoport létrehozva.');
        this.ujCsoport = { name: '', ev, hianyzas_szamit: true, opcionalis_reszvetel: false, foglalkozas_tipus: '' };
        this.ujCsoportForm = false;
        this.csoportokBetoltese();
        if (resp?.id) setTimeout(() => this.csoportValasztas(resp.id), 300);
      },
      error: (err) => {
        this.csoportLetrehozasFolyamatban = false;
        this.data.sendToast(err?.error?.error || 'Nem sikerült létrehozni a csoportot.', 'error');
      },
    });
  }

  async csoportPickerNyitas() {
    const modal = await this.modalCtrl.create({
      component: EntityPickerModalComponent,
      componentProps: {
        title: 'Csoport választása',
        searchPlaceholder: 'Csoport neve…',
        multiple: false,
        selectedIds: this.kivalasztottCsoport ? [this.kivalasztottCsoport.id] : [],
        items: this.csoportok
          .filter((c: any) => (!this.csakOraNelkuli || !Number(c.orak))
                           && (!this.csakUres || (!Number(c.orak) && !Number(c.tanulo_db))))
          .map((c: any) => ({
            id: c.id,
            label: c.name,
            sublabel: [
              c.ev ? `${c.ev}` : '',
              c.tanulo_db ? `${c.tanulo_db} tanuló` : '',
              Number(c.orak) ? `${c.orak} óra` : 'nincs órája',
            ].filter(Boolean).join(' · ') || undefined,
          })),
      },
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && data?.ids?.length) {
      this.csoportValasztas(data.ids[0]);
    }
  }

  csoportValasztas(csoportId: string) {
    this.kivalasztottCsoport = this.csoportok.find((c) => c.id === csoportId) || null;
    //  Az automatikus típus a kiszolgálón NULL, a választóban az üres érték.
    if (this.kivalasztottCsoport) this.kivalasztottCsoport.foglalkozas_tipus = this.kivalasztottCsoport.foglalkozas_tipus || '';
    this.tanulok = [];
    this.szurtTanulok = [];
    this.kivalasztottTantargyIds = [];
    this.ujNev = this.kivalasztottCsoport?.name || '';
    if (!this.kivalasztottCsoport) return;
    this.tanulokBetoltese();
    this.tantargyakBetoltese();
  }

  tantargyakBetoltese() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    const ev = Number(this.kivalasztottCsoport.ev) || new Date().getFullYear();
    // Összes tantárgy (a csoport éve szerint) + a csoporthoz társítottak
    this.http.get<any[]>(`/api/nyilvantartas/tantargy/${ev}/${this.intezmenyId}`).subscribe({
      next: (rows) => { this.osszesTantargy = Array.isArray(rows) ? rows : []; },
      error: () => this.data.sendToast('Nem sikerült betölteni a tantárgyakat.', 'error'),
    });
    this.http
      .get<any[]>(`/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/tantargyak/${this.intezmenyId}`)
      .subscribe({
        next: (rows) => {
          this.kivalasztottTantargyIds = (Array.isArray(rows) ? rows : []).map((r) => String(r.tantargy_id));
        },
        error: () => this.data.sendToast('Nem sikerült betölteni a csoport tantárgyait.', 'error'),
      });
  }

  tantargyakMentese() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    this.tantargyMentes = true;
    this.http
      .put(`/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/tantargyak/${this.intezmenyId}`, {
        tantargyak: this.kivalasztottTantargyIds,
      })
      .subscribe({
        next: () => { this.tantargyMentes = false; this.data.sendToast('A csoport tantárgyai mentve.'); },
        error: () => { this.tantargyMentes = false; this.data.sendToast('Nem sikerült menteni a tantárgyakat.', 'error'); },
      });
  }

  tanulokBetoltese() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    this.betoltes = true;
    this.http
      .get<TanuloCsoportSor[]>(
        `/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/tanulok/${this.intezmenyId}`
      )
      .subscribe({
        next: (rows) => {
          this.tanulok = (Array.isArray(rows) ? rows : []).map((row) => ({
            ...row,
            selected: !!row.csoportban,
          }));
          this.szures();
          this.betoltes = false;
        },
        error: () => {
          this.betoltes = false;
          this.data.sendToast('Nem sikerült betölteni a tanulókat.', 'error');
        },
      });
  }

  szures() {
    const term = this.normalize(this.kereses);
    this.szurtTanulok = this.tanulok.filter((tanulo) => {
      if (this.csakTagok && !tanulo.selected) return false;
      if (!term) return true;
      return [
        tanulo.full_name,
        tanulo.oktazon,
        tanulo.adid,
        tanulo.aktualis_osztaly,
      ].some((value) => this.normalize(value).includes(term));
    });
  }

  osszesLathatoKijelolese(selected: boolean) {
    for (const tanulo of this.szurtTanulok) {
      tanulo.selected = selected;
    }
  }

  mentesInditasa() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    const tanulok = this.tanulok.filter((tanulo) => tanulo.selected).map((tanulo) => tanulo.oktazon);

    const hatar = this.tanevHatar;
    const kivul = (d: string) => !!hatar && (d < hatar.min || d > hatar.max);
    if (this.felvendoDb && (!this.belepesNapja || kivul(this.belepesNapja))) {
      this.data.sendToast(`A belépés napja a csoport tanévén belül legyen (${hatar?.min} – ${hatar?.max}).`, 'warning');
      return;
    }
    if (this.kiveendoDb && (!this.kilepesNapja || kivul(this.kilepesNapja))) {
      this.data.sendToast(`A kilépés napja a csoport tanévén belül legyen (${hatar?.min} – ${hatar?.max}).`, 'warning');
      return;
    }

    this.mentes = true;
    this.http
      .put<any>(`/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/tanulok/${this.intezmenyId}`, {
        tanulok,
        kezdete: this.belepesNapja,
        kilepes: this.kilepesNapja,
      })
      .subscribe({
        next: (r) => {
          this.mentes = false;
          const reszek = [
            r?.felvett ? `${r.felvett} felvéve ${r.belepes}-tól` : '',
            r?.kivett ? `${r.kivett} kivéve ${r.kilepes}-tól` : '',
            r?.kreta_atvezetendo ? `${r.kreta_atvezetendo} KRÉTA-ban átvezetendő` : '',
          ].filter(Boolean);
          this.data.sendToast(`A csoportbesorolás mentve${reszek.length ? ': ' + reszek.join(', ') : ''}.`);
          this.csoportokBetoltese();
          this.tanulokBetoltese();
        },
        error: (e) => {
          this.mentes = false;
          this.data.sendToast(e?.error?.error && typeof e.error.error === 'string'
            ? e.error.error : 'Nem sikerült menteni a csoportbesorolást.', 'error');
        },
      });
  }

  /**
   *  Csoport átnevezése. A besorolások, az órarend és a tantárgyfelosztás a csoport
   *  AZONOSÍTÓJÁRA hivatkozik, ezért az átnevezés semmit nem szakít el – csak a
   *  megjelenő név változik (az aSc export is emiatt frissít, nem duplikál).
   */
  csoportAtnevezes() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    const nev = String(this.ujNev || '').trim();
    if (!nev) { this.data.sendToast('A csoport neve nem lehet üres.', 'warning'); return; }

    this.nevMentes = true;
    this.http
      .patch<any>(`/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/${this.intezmenyId}`, { name: nev })
      .subscribe({
        next: () => {
          this.nevMentes = false;
          if (this.kivalasztottCsoport) this.kivalasztottCsoport.name = nev;
          const sor = this.csoportok.find((c) => c.id === this.kivalasztottCsoport?.id);
          if (sor) sor.name = nev;
          this.data.sendToast('A csoport átnevezve.');
        },
        error: (err) => {
          this.nevMentes = false;
          this.data.sendToast(err?.error?.error || 'Az átnevezés nem sikerült.', 'error');
        },
      });
  }

  /**
   *  Csoport törlése. A backend csak ÜRES csoportot enged törölni – ha van benne
   *  tanuló, órarendi óra vagy tantárgyfelosztás, a hibaüzenet megmondja, mi tartja.
   */
  csoportTorles() {
    const cs = this.kivalasztottCsoport;
    if (!cs?.id) return;
    if (!confirm(`Törlöd a(z) „${cs.name}" csoportot? Csak akkor sikerül, ha üres.`)) return;

    this.http.delete<any>(`/api/tanuloi-csoport/csoport/${cs.id}/${this.intezmenyId}`).subscribe({
      next: () => {
        this.data.sendToast(`A(z) „${cs.name}" csoport törölve.`);
        this.kivalasztottCsoport = null;
        this.tanulok = [];
        this.szurtTanulok = [];
        this.csoportokBetoltese();
      },
      error: (err) => this.data.sendToast(err?.error?.error || 'A törlés nem sikerült.', 'error'),
    });
  }

  /*  Az aktuális (munkatanévre szűrt) listából azok, amelyekhez egyetlen óra sem tartozik. */
  get oraNelkuliCsoportok(): Csoport[] {
    return this.csoportok.filter((c: any) => !Number(c.orak));
  }

  /*  Teljesen üres csoportok: se óra, se tanuló. */
  get uresCsoportok(): Csoport[] {
    return this.csoportok.filter((c: any) => !Number(c.orak) && !Number(c.tanulo_db));
  }

  /**
   *  ÓRA NÉLKÜLI CSOPORTOK TÖRLÉSE EGYBEN.
   *
   *  Két lépés: előbb a backend megmondja, mi mi lenne (mit tart vissza kemény adat,
   *  melyiknek van névsora), és csak a megerősítés után törlünk. A névsoros csoport
   *  külön kérdés – az egy élő csoport, aminek „csak" az órarendje hiányzik.
   */
  oraNelkuliTorles() { return this.tomegesTorlesInditas(this.oraNelkuliCsoportok, 'Óra nélküli csoportok'); }

  /*  Az üres csoportnak se névsora, se órája – itt a névsor-kérdés fel sem merül,
   *  a takarítás egy kattintás. */
  uresTorles() { return this.tomegesTorlesInditas(this.uresCsoportok, 'Üres csoportok'); }

  async tomegesTorlesInditas(jeloltek: Csoport[], cimke: string) {
    if (!jeloltek.length) { this.data.sendToast('Nincs ilyen csoport.'); return; }

    const ids = jeloltek.map((c) => c.id);
    const url = `/api/tanuloi-csoport/torles-tomeges/${this.intezmenyId}`;
    this.tomegesTorles = true;

    let terv: any;
    try {
      terv = await this.http.post<any>(url, { ids, elonezet: true }).toPromise();
    } catch (err: any) {
      this.tomegesTorles = false;
      this.data.sendToast(err?.error?.error || 'Nem sikerült megnézni, mi törölhető.', 'error');
      return;
    }

    const tiszta = terv?.torolheto?.length || 0;
    const nevsoros = terv?.nevsoros || [];
    const akadalyos = terv?.akadalyos || [];
    const tanuloDb = nevsoros.reduce((sum: number, c: any) => sum + (Number(c.tanulo_db) || 0), 0);

    if (!tiszta && !nevsoros.length) {
      this.tomegesTorles = false;
      this.data.sendToast(
        akadalyos.length
          ? `Egyik óra nélküli csoport sem törölhető: ${akadalyos.length} csoportot más adat tart (pl. tantárgyfelosztás).`
          : 'Nincs törölhető csoport.',
        'warning');
      return;
    }

    const sorok = [
      `${tiszta} csoport üres (se óra, se névsor) – ezek törölhetők.`,
      nevsoros.length ? `${nevsoros.length} csoportnak VAN névsora (${tanuloDb} besorolás).` : '',
      akadalyos.length ? `${akadalyos.length} csoportot más adat tart, azokat kihagyjuk.` : '',
    ].filter(Boolean).join('\n');

    if (!confirm(`${cimke} törlése:\n\n${sorok}\n\nFolytatod?`)) {
      this.tomegesTorles = false;
      return;
    }

    let nevsorral = false;
    if (nevsoros.length) {
      nevsorral = confirm(
        `A névsoros csoportok is menjenek?\n\n${nevsoros.length} csoport, ${tanuloDb} tanulói besorolás VÉGLEG törlődik.\n`
        + 'OK = a névsorosak is · Mégse = csak a teljesen üresek');
      if (!nevsorral && !tiszta) { this.tomegesTorles = false; return; }
    }

    this.http.post<any>(url, { ids, nevsorral }).subscribe({
      next: (resp) => {
        this.tomegesTorles = false;
        this.kivalasztottCsoport = null;
        this.tanulok = [];
        this.szurtTanulok = [];
        this.csoportokBetoltese();
        const maradt = (resp?.kihagyva?.length || 0) + (resp?.nevsoros?.length || 0);
        this.data.sendToast(
          `${resp?.torolve || 0} csoport törölve`
          + (resp?.tanulo_torolve ? `, ${resp.tanulo_torolve} besorolással együtt` : '')
          + (maradt ? ` · ${maradt} csoport maradt (nem volt törölhető).` : '.'));
      },
      error: (err) => {
        this.tomegesTorles = false;
        this.data.sendToast(err?.error?.error || 'A tömeges törlés nem sikerült.', 'error');
      },
    });
  }

  /*  ÚJ CSOPORTNÁL a nem tanórai típus kényelmi alapértéke: a hiányzás ne számítson (a napközi,
   *  szakkör, tanulószoba hiányzása eddig is így volt). Visszakapcsolható – a sportkör például a
   *  mindennapos testnevelés része lehet, ott a hiányzás számít, ezért annál nem nyúlunk hozzá. */
  ujCsoportTipusValt() {
    const t = this.ujCsoport.foglalkozas_tipus;
    if (t && t !== 'tanorai' && t !== 'sportkor') this.ujCsoport.hianyzas_szamit = false;
    if (t === 'tanorai') this.ujCsoport.hianyzas_szamit = true;
  }

  /** Meglévő csoport típusa: csak a típust menti, a hiányzás-kapcsolóhoz nem nyúl. */
  foglalkozasTipusMentes() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    this.http
      .patch(`/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/${this.intezmenyId}`, {
        foglalkozas_tipus: this.kivalasztottCsoport.foglalkozas_tipus || null,
      })
      .subscribe({
        next: () => this.data.sendToast('A foglalkozás típusa mentve.'),
        error: (err) => this.data.sendToast(err?.error?.error || 'Nem sikerült menteni a típust.', 'error'),
      });
  }

  /** A típus és a hiányzás-kapcsoló eltér-e a szokásostól (figyelmeztetéshez). */
  get tipusEltero(): string {
    const c = this.kivalasztottCsoport;
    const t = c?.foglalkozas_tipus || '';
    if (!c || !t) return '';
    if (t === 'tanorai' && !c.hianyzas_szamit) return 'Tanórai csoport, de a hiányzás nem számít az óráin.';
    if (!['tanorai', 'sportkor'].includes(t) && c.hianyzas_szamit) return 'Egyéb foglalkozás, de a hiányzás beleszámít a tanuló mulasztásába. Ha ez nem szándékos, kapcsold ki.';
    return '';
  }

  hianyzasKapcsolo() {
    if (!this.intezmenyId || !this.kivalasztottCsoport?.id) return;
    // Opcionális részvétel csak nem tanórai célú (hiányzás nélküli) csoportnál; ha a hiányzás visszakapcsol, töröljük.
    if (this.kivalasztottCsoport.hianyzas_szamit) this.kivalasztottCsoport.opcionalis_reszvetel = 0 as any;
    this.http
      .patch(`/api/tanuloi-csoport/csoport/${this.kivalasztottCsoport.id}/${this.intezmenyId}`, {
        hianyzas_szamit: this.kivalasztottCsoport.hianyzas_szamit ? 1 : 0,
        opcionalis_reszvetel: (!this.kivalasztottCsoport.hianyzas_szamit && this.kivalasztottCsoport.opcionalis_reszvetel) ? 1 : 0,
      })
      .subscribe({
        next: () => this.data.sendToast('A csoport beállítása mentve.'),
        error: () => this.data.sendToast('Nem sikerült menteni a beállítást.', 'error'),
      });
  }

  get kijeloltDb(): number {
    return this.tanulok.filter((tanulo) => tanulo.selected).length;
  }

  /** Mentéskor felvett (eddig nem tag, most kijelölt) tanulók száma. */
  get felvendoDb(): number {
    return this.tanulok.filter((t) => t.selected && !t.csoportban).length;
  }

  /** Mentéskor kivett (eddig tag, most nem kijelölt) tanulók száma. */
  get kiveendoDb(): number {
    return this.tanulok.filter((t) => !t.selected && !!t.csoportban).length;
  }

  /** A csoport tanévének határai a dátummezőkhöz (a kiszolgáló ugyanezt ellenőrzi). */
  get tanevHatar(): { min: string; max: string } | null {
    const ev = Number(this.kivalasztottCsoport?.ev) || 0;
    return ev ? { min: `${ev}-09-01`, max: `${ev + 1}-08-31` } : null;
  }

  private normalize(value: any): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }
}
